<template>
  <div class="synchronization">
    <!-- Synchronization -->
    <div class="bg-black p-2 rounded">
      <div class="row mt-1">
          <div class="col-md-3">
              <input class="btn bg-black text-white text-start fw-light fs-2 rounded w-100" style="width: 200px; margin-top: -5px; cursor: default;" type="text" value="Synchronization" readonly>
          </div>
          <div class="col-md-6"></div>
          <div class="col-md-2">
              <input class="btn bg-black text-white text-start fw-light fs-5 rounded w-100" style="width: 200px; margin-top: 5px; cursor: default;" type="text" :value="timestamp" readonly>
          </div>
          <div class="col-md-1">
            <!-- Refresh Summary -->
            <button class="btn bg-black text-white fs-3 rounded" style="width: 100px;" title="Refresh Servers Data" @click="getServers">
                <i class="fa-solid fa-xl fa-arrows-rotate" :class="{'fa-spin': gettingServers}"></i>
            </button>
          </div>
      </div>
    </div>
    <!-- Servers -->
    <div>
      <div v-for="(server, index) in servers" v-bind:key="index+1" class="bg-black p-2 rounded mt-2">
        <div class="row">
              <div class="col-md-1">
                <div class="input-group flex-nowrap" style="height: 100%">
                  <button class="btn text-white fs-6 w-100" :class="{'btn-success': server.status=='synchronized', 'btn-danger': server.status=='unsynchronized', 'btn-unknown': (server.status!='synchronized' && server.status!='unsynchronized')}" readonly>
                    <i class="fa-solid fa-link"></i>
                  </button>
                </div>
              </div>
              <div class="col-md-3">
                <div class="input-group flex-nowrap">
                  <button class="btn btn-sync text-black fs-6" title="Server" readonly>
                    <i class="fa-solid fa-server"></i>
                    Server
                  </button>
                  <input class="btn input-sync fs-6" type="text" :value="server.ip" style="pointer-events: none;" readonly>
                </div>
              </div>
              <div class="col-md-3">
                <div class="input-group flex-nowrap">
                  <button class="btn btn-sync text-black fs-6" title="Server" readonly>
                    <i class="fa-solid fa-clock"></i>
                    Clock
                  </button>
                  <input class="btn input-sync fs-6" type="text" :value="server.clock" style="pointer-events: none;" readonly>
                </div>
              </div>
              <div class="col-md-2">
                <div class="input-group flex-nowrap">
                  <button class="btn btn-sync text-black fs-6 w-50" title="Stratum" readonly>
                    <i class="fa-solid fa-layer-group"></i>
                    Stratum
                  </button>
                  <input class="btn input-sync fs-6 w-50" type="text" :value="server.stratum" style="pointer-events: none;" readonly>
                </div>
              </div>
              <div class="col-md-3">
                <div class="input-group flex-nowrap">
                  <button class="btn btn-sync text-black fs-6" style="width: 20%;" title="Status" readonly>
                    <i class="fa-solid fa-info"></i>
                  </button>
                  <input class="btn input-sync fs-6" type="text" :value="capitalize(server.status)" style="pointer-events: none;" readonly>
                </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
// Import the component with the line below.
//import Base from '@/components/Base.vue'

import axios from "axios";

export default {
  name: 'Synchronization',
  components: {},
  data(){
    return {
      // General for the requests.
      site: null,
      stage: null,
      // App
      gettingServers: false,
      servers: [],
      timestamp: "-"
    }
  },
  methods:{
    capitalize(_string){
      const lower = _string.toLowerCase()
      return _string.charAt(0).toUpperCase() + lower.slice(1)
    },
    getServers(){
      this.gettingServers = true
      this.servers = []
      this.timestamp = "Getting status..."
      const params = {listener: this.pollingListener}
      const dest = this.site + '/kairos/synchronization/getStatus'
      axios
          .get(dest, {params})
          .then(rx => {
              this.gettingServers = false
              this.servers = rx.data.data
              this.timestamp = rx.data._timestamp_
          })
          .catch(error => {
            this.processErrorMessage(error)
            this.gettingServers = false
          });
    },
    // Errors
    processErrorMessage(error, mode="alert"){
        var err_message = null
        try {
            err_message = error.response.data.data.errorMessage
        } 
        catch (nerror) {
            try { 
                err_message = error.response.data.errorMessage
            } 
            catch (error) { 
                console.log(error) 
            }
        }
        if (mode == "alert"){ alert(err_message)  }
        else if (mode == "console"){ console.log(err_message)  }
    return err_message
    },
    getCookie(name){
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + '=')) {
              return cookie.substring(name.length + 1);
            }
      }
      return null;
    }
  },
  mounted: function(){},
  created: function(){
    this.stage = process.env.NODE_ENV

    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    // Setting
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
    this.getServers()
  }
}
</script>

<style scoped>

  .btn-sync{
    color: White;
    background-color: rgb(15, 182, 7);
  }

  .input-sync{
    color: White;
    background-color: rgb(37,24,52);
  }

  .btn-unknown{
    color: White;
    background-color: rgb(164, 106, 0);
  }

</style>
